import { useLocalStorage } from '@vueuse/core';

const OFFLINE_FAVORITES_KEY = 'shorts:offlineFavorites';

interface OfflineFavoritesData {
	ids: string[];
}

const DEFAULT_DATA: OfflineFavoritesData = { ids: [] };

export function useOfflineFavorites() {
	const data = useLocalStorage<OfflineFavoritesData>(
		OFFLINE_FAVORITES_KEY,
		DEFAULT_DATA
	);

	function isOfflineFavorite(propertyId: string): boolean {
		return data.value.ids.includes(propertyId);
	}

	function addOfflineFavorite(propertyId: string): void {
		if (!data.value.ids.includes(propertyId)) {
			data.value.ids = [...data.value.ids, propertyId];
		}
	}

	function removeOfflineFavorite(propertyId: string): void {
		data.value.ids = data.value.ids.filter(id => id !== propertyId);
	}

	function getIds(): string[] {
		return [...data.value.ids];
	}

	function clearAll(): void {
		data.value = { ids: [] };
	}

	return {
		isOfflineFavorite,
		addOfflineFavorite,
		removeOfflineFavorite,
		getIds,
		clearAll
	};
}
